import { useLocation, useNavigate } from "react-router-dom";

import { TabDefinition, TabPager } from "@interco/inter-ui/components/TabPager";
import { ReactComponent as InterLogo } from "@/assets/inter.svg";

import SimuladorIcon from "@interco/icons/orangeds/MD/salary-portability";
import ProposalsIcon from "@interco/icons/orangeds/MD/receipt";
import { tabIdFromPathname, tabNames, tabRoutes } from "@/utils/tabNames";

import * as S from "./styles";
import UserMenu from "@/components/UserMenu";

const iconProps = {
  height: 20,
  width: 20,
  color: "#FF7A00",
};

const tabDefinitions: TabDefinition[] = [
  {
    tabId: tabNames.simulator,
    label: (
      <S.StyledTab>
        <SimuladorIcon {...iconProps} />
        <span>Simulador</span>
      </S.StyledTab>
    ),
    content: <></>,
  },
  {
    tabId: tabNames.proposals,
    label: (
      <S.StyledTab>
        <ProposalsIcon {...iconProps} />
        <span>Propostas</span>
      </S.StyledTab>
    ),
    content: <></>,
  },
];

const Header = ({ userInfo }: { userInfo?: UserInfo }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentTab = tabIdFromPathname(pathname);

  const handleTabChange = (tabId: string | number) => {
    navigate(tabRoutes[tabId]);
  };

  return (
    <S.StyledHeader>
      <S.StyledBar>
        <S.StyledTitle>
          <InterLogo width={112} />
          <S.StyledPrincipalHeading variant="headline-h1">
            Portal Imobiliário
          </S.StyledPrincipalHeading>
        </S.StyledTitle>

        <UserMenu name={userInfo?.parceiroNome} />
      </S.StyledBar>

      <TabPager
        currentTabId={currentTab}
        onTabSelect={handleTabChange}
        tabDefinitions={tabDefinitions}
        tabPanelStyle={{
          display: "none",
        }}
        tabItemStyle={{
          color: 'var(--neutral500)'
        }}
      />
    </S.StyledHeader>
  );
};

export default Header;
